import { createContext, useContext, useMemo } from 'react';
import { useApiQuery } from '../../query';
import {
  getLsObject,
  removeLsObject,
} from '@im/ui-lib/utils/local-storage.utils';
import { useFeatureFlag } from '../../feature-flag';

/** Query for campaign validation*/
export function useCampaignConfig() {
  const campaginId = useMemo(() => {
    return getLsObject('cms_c_id', '')[0];
  }, []);
  const campaginType = useMemo(() => {
    return getLsObject('cms_c_id', '')[1];
  }, []);

  const { value: isFeatureFlag } = useFeatureFlag('X4C_IsBICampaignRestricted');
  const isRestricted = isFeatureFlag === 'true';
  const { data, isError, isLoading } = useApiQuery<CampaignConfigResponse>(
    `/cms.webapi.digitalmarketing/cms/v1/campaigns/${campaginId}/${campaginType}`,
    { BICampaignRestricted: isRestricted },
    {
      enabled: !!campaginId && !!isFeatureFlag,
      gcTime: Infinity,
      staleTime: Infinity,
    }
  );
  return useMemo(() => {
    const isConfigValid = !!campaginId && !isLoading && !isError;
    if (isConfigValid && data?.isvalid === 'false') {
      removeLsObject('cms_c_id');
    }
    return {
      campaignId: campaginId,
      isEnabled: isConfigValid && data?.isvalid === 'true',
    } as ICampaignConfigContext;
  }, [campaginId, data, isError, isLoading]);
}

/** context for campaign configuration for users */
export const campaignContext = createContext<ICampaignConfigContext>({
  campaignId: '',
  isEnabled: false,
});

/** Access logoutContextData.
 */
export function useCampaignContext() {
  const defaultVal: ICampaignConfigContext = {
    campaignId: '',
    isEnabled: false,
  };
  const context = useContext(campaignContext);
  return context ?? defaultVal;
}

export interface ICampaignConfigContext {
  campaignId: string;
  isEnabled: boolean;
}

export interface CampaignConfigResponse {
  campaigns: Campaign[];
  isvalid: string;
  status: string;
}

export interface Campaign {
  campaignid?: string;
  enddate?: string;
  groupvendor?: string;
  startdate?: string;
  url_expiry_date?: string;
}
